import { isDTRuntime } from '@/modules/3rd-party-integration/utils/env';
import React from 'react';
import DingtalkAvatar from './DingtalkAvatar';
import LoggedInAvatar from './LoggedInAvatar';
import UnLoggedInAvatar from './UnLoggedInAvatar';

export default function HeaderAvatar({ userInfo ,renderLangMenu }) {
    if (isDTRuntime) {
        return <DingtalkAvatar userInfo={userInfo} />
    }
    if (userInfo) {
        return <LoggedInAvatar renderLangMenu={renderLangMenu} />
    }
    return <UnLoggedInAvatar />
}
